import React, { useEffect, useState } from 'react';
import Option from './../SelectTop1Response/Option';
import LockInButton from './../LockInButton/LockInButton'
import Tooltip from '@mui/material/Tooltip';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(theme => ({
  arrow: {
    "&:before": {
      border: "1px solid #E7DCDA",
      backgroundColor: "#B2292D",
    },
    color: "#FFF",
    // zIndex: 1,
  },
  tooltip: {
    backgroundColor: "#B2292D",
    border: "1px solid #E7DCDA",
    color: "#FFF",
    fontSize: '12pt',
    // zIndex: 1,
  }
}));


function SelectTop1Response(props) {
  const [selectedID, setSelectedID] = useState(null) 

  let classes = useStyles();

  function selectOption(id) {
    if (!props.responseSubmitted) {
      setSelectedID(id)
    }
  }

  useEffect(() => {
    setSelectedID(null) // reset for questions in the same station
  }, [props.options])

  return (
    <div className='response-container'>
      <Tooltip title="Select the top answer" arrow open={props.displayTooltip && selectedID === null} placement='right' classes={{ arrow: classes.arrow, tooltip: classes.tooltip}}>
        <div>
          {props.options.map((option, index) => (
            <Option key={option.id} option={option} index={index} isSelected={selectedID === option.id} handleClick={() => selectOption(option.id)} responseSubmitted={props.responseSubmitted}/>
          ))}   
        </div>
      </Tooltip> 
      { props.responseSubmitted? null : 
        <LockInButton disabled={selectedID === null} response={selectedID} handleLockInResponse={props.handleLockInResponse}/> 
      } 
    </div>
  );
}

export default SelectTop1Response;
